import { render, staticRenderFns } from "./ConfigRoleDataTable.vue?vue&type=template&id=218fa8fa&scoped=true"
import script from "./ConfigRoleDataTable.vue?vue&type=script&lang=js"
export * from "./ConfigRoleDataTable.vue?vue&type=script&lang=js"
import style0 from "./ConfigRoleDataTable.vue?vue&type=style&index=0&id=218fa8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218fa8fa",
  null
  
)

export default component.exports